/**
 * Shows a floating "In Sub-Prozess umwandeln" action button whenever
 * two or more BPMN shapes are selected.  The button is positioned at
 * the top-right corner of the selection bounding box.
 *
 * Clicking it fires `wrapInSubProcess.requestDialog` which opens the
 * React dialog in App.js.
 */
export default function MultiSelectActionProvider(eventBus, selection, canvas) {
  let actionDiv = null;

  function removeButton() {
    actionDiv?.remove();
    actionDiv = null;
  }

  function createButton(bbox) {
    removeButton();

    const container = canvas.getContainer();

    actionDiv = document.createElement('div');
    actionDiv.className = 'multi-select-action';
    actionDiv.title = 'In Sub-Prozess umwandeln (Ctrl+G)';
    actionDiv.innerHTML =
      '<i class="bpmn-icon-subprocess-collapsed"></i>' +
      '<span>In Sub-Prozess</span>';

    // Position: below the bounding box, centered horizontally
    // Translate diagram coordinates to container-relative px
    const viewbox = canvas.viewbox();
    const centerX = ((bbox.minX + bbox.maxX) / 2 - viewbox.x) * viewbox.scale;
    const bottomY = (bbox.maxY - viewbox.y) * viewbox.scale + 10;

    actionDiv.style.left = centerX + 'px';
    actionDiv.style.top = bottomY + 'px';
    actionDiv.style.transform = 'translateX(-50%)';

    actionDiv.addEventListener('click', (e) => {
      e.stopPropagation();
      const elements = selection.get();
      if (elements.length >= 2) {
        eventBus.fire('wrapInSubProcess.requestDialog', { count: elements.length });
      }
    });

    container.appendChild(actionDiv);
  }

  function updateButton() {
    const elements = selection.get();

    // Only shapes (not connections)
    const shapes = elements.filter(el => !el.waypoints);
    if (shapes.length < 2) {
      removeButton();
      return;
    }

    // Compute bounding box of selected shapes
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const s of shapes) {
      minX = Math.min(minX, s.x);
      minY = Math.min(minY, s.y);
      maxX = Math.max(maxX, s.x + s.width);
      maxY = Math.max(maxY, s.y + s.height);
    }

    createButton({ minX, minY, maxX, maxY });
  }

  eventBus.on('selection.changed', updateButton);
  eventBus.on('canvas.viewbox.changed', () => {
    // Reposition if still showing
    if (actionDiv) updateButton();
  });

  // Remove on root change (drill-down into sub-process)
  eventBus.on('root.set', removeButton);
}

MultiSelectActionProvider.$inject = ['eventBus', 'selection', 'canvas'];
